import axios from 'axios';

export default {
  getAll() {
    return axios.get('/restaurant/areas/labels');
  },

  getById(id) {
    return axios.get(`/restaurant/areas/labels/${id}`);
  },

  getByAreaId(areaId) {
    return axios.get(`/restaurant/areas/${areaId}/labels`);
  },

  create(data) {
    return axios.post('/restaurant/areas/labels', data);
  },

  update(id, data) {
    return axios.put(`/restaurant/areas/labels/${id}`, data);
  },

  delete(id) {
    return axios.delete(`/restaurant/areas/labels/${id}`);
  }
}
